export default __webpack_public_path__ + "assets/models/a0de575ddcf6b8e3dde00176530db995.glb";